module.exports = __webpack_public_path__ + "static/img/r-4-2-icon.c181fe5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/layer3/en/role-4/r-4-2-icon.png
// module id = kEHJ
// module chunks = 0